<!-- 导热系数 -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getCOPPERFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: '398W'
    },
    // 铜基结构
    copper_structure: {
      type: Number,
      default: 2
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getCOPPERFields('heat_factor')
    },
    options() {
      const { fields, copper_structure, val } = this
      let options = fields.options

      // 1-非热电分离 禁用 398W 
      // 2-热电分离 禁用 1W 2W 3W
      const disabledOptions = { 1: ['398W'], 2: ['1W', '2W', '3W'] }[copper_structure] || []

      // 如果当前项被禁用
      if (disabledOptions.includes(val)) {
        this.changeVal({ 1: '1W', 2: '398W' }[copper_structure])
      }
      
      return options.map(item => ({...item, disabled: disabledOptions.includes(item.value) }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>